(ns java.time.format
  (:require [goog.object]
            ["@js-joda/core" :as js-joda]))

(def DateTimeFormatter (goog.object/get js-joda "DateTimeFormatter"))
(def DateTimeFormatterBuilder (goog.object/get js-joda "DateTimeFormatterBuilder"))
(def DecimalStyle (goog.object/get js-joda "DecimalStyle"))
(def ResolverStyle (goog.object/get js-joda "ResolverStyle"))
(def SignStyle (goog.object/get js-joda "SignStyle"))
(def TextStyle (goog.object/get js-joda "TextStyle"))
